import React from 'react';
import {PieChart, Pie, Cell} from 'recharts';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {formatDollarOrEmptyString} from 'common/utils';
import {Loader} from 'semantic-ui-react';

const COLORS = [
  '#68023F',
  '#008169',
  '#EF0096',
  '#00DCB5',
  '#FFCFE2',
  '#003C86',
  '#9400E6',
  '#009FFA',
  '#FF71FD',
  '#7CFFFA',
  '#6A0213',
  '#008607',
  '#F60239',
  '#00E307',
  '#FFDC3D',
];

export const FEMAGOPieChart = (props) => {
  const dataPath = _.get(props, 'dataPath', '');
  const data = _.get(props, 'data', _.get(props, dataPath, {data: [], loading: true}));
  const dataKey = _.get(props, 'dataKey', 'value');
  const formatAsDollar = _.get(props, 'formatAsDollar', true);
  const fmt = (str) => (formatAsDollar ? formatDollarOrEmptyString(`${str}`) : `${str}`);
  const dataLabel = _.get(props, 'dataLabel', 'name');
  const title = _.get(
    props,
    'title',
    `Total requested federal share (${fmt(_.sum(data.data.map((d) => d[dataKey])))})`
  );
  const colors = _.get(props, 'colors', COLORS);

  return (
    <>
      {data.loading ? (
        <div
          className="margin-top"
          style={{minHeight: 300, display: 'flex', alignItems: 'center'}}
        >
          <Loader inline="centered" size="large" active>
            Loading...
          </Loader>
        </div>
      ) : !data.data.length ? (
        <div></div>
      ) : (
        <div
          style={{
            marginTop: 23,
            marginLeft: 8,
            marginRight: 46,
            marginBottom: 41,
            padding: 24,
          }}
        >
          <h2
            className="ui header"
            style={{
              fontSize: 22,
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '120%',
              letterSpacing: 0.22,
              paddingBottom: 13,
            }}
          >
            {title}
          </h2>
          <div className="ui grid">
            <div
              className="column"
              style={{width: 340, fontFamily: `'Public Sans', sans-serif`}}
            >
              <PieChart width={312} height={312}>
                <Pie
                  data={data.data}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={156}
                  fill="#8884d8"
                  dataKey={dataKey}
                >
                  {data.data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
              </PieChart>
            </div>
            <div className="column" style={{width: 500, paddingTop: 17, paddingLeft: 44}}>
              {data.data.map((entry, index) => (
                <div
                  key={`label-${index}`}
                  style={{
                    paddingTop: 6,
                    display: 'flex',
                    fontSize: 16,
                    fontStyle: 'normal',
                    fontWeight: '400',
                    lineHeight: '162%',
                  }}
                >
                  <div
                    style={{
                      display: 'inline-block',
                      width: 50,
                      height: 14,
                      flexShrink: 0,
                      marginRight: 9,
                      alignSelf: 'center',
                      color: colors[index % colors.length],
                      background: colors[index % colors.length],
                    }}
                  ></div>
                  <span>
                    {entry[dataLabel]}&nbsp;
                    <span style={{fontWeight: 'bold'}}> ({fmt(entry[dataKey])})</span>
                  </span>
                  <br></br>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connectDynamic(FEMAGOPieChart);
